import { useState, useEffect, useRef } from 'react';
import { Routes, Route, useNavigate, Outlet } from 'react-router-dom';
import { ProSidebar, Menu, MenuItem, SidebarFooter, SidebarHeader } from 'react-pro-sidebar';
import { collection, query, onSnapshot } from 'firebase/firestore';
import TopBar from "./TopBar";
import Restaurants from './Restaurants';
import RestaurantEditor from './RestaurantEditor';
import MenuEditor from './MenuEditor';
import DeleteRes from './Editor/DeleteRes';
import Recommends from './Recommends';
import '../Styles/main.scss';
import { 
    MdChevronRight, MdChevronLeft, MdDashboard, 
    MdFastfood, MdVerified, MdClose
} from 'react-icons/md';
import Welcome from './Welcome';

const logo320 = require('../Images/miniLogo.png');

const MainView = (props) => {

    const [isPopUp, togglePopUp] = useState(false);
    const [popContent, setPopContet] = useState(<></>);
    const [popTitle, setPopTitle] = useState('Editar Algo');

    const [sidebarShow, toggleSidebar] = useState(false);
    const [sidebarCollapse, collapseSidebar] = useState(false);
    const [restaurantList, setResList] = useState([]);
    const restaurantListRef = useRef();
          restaurantListRef.current = restaurantList;
    const [currentRestaurant, setCurrentRes] = useState(null);

    const [recommendList, setRecList] = useState([]);
    const recommendListRef = useRef();
          recommendListRef.current = recommendList;
    const changeMainPath = useNavigate();

    useEffect(() => {
        // Get Restaurants
        const q = query(collection(props.eDB, 'Restaurants'));
        const unsubscribe_res = onSnapshot(q, (snapshot) => {
            let newList = restaurantListRef.current.slice();

            snapshot.docChanges().forEach((change) => {
                if(change.type === "added"){
                    let elem = {...change.doc.data(),id: change.doc.id};
                    newList.push(elem);
                }

                if(change.type === "modified"){
                    let index = restaurantListRef.current.findIndex((res) => { return res.id === change.doc.id});
                    newList.splice(index, 1, {...change.doc.data(), id: change.doc.id});
                }

                if(change.type === "removed"){
                    newList = newList.filter((res) => {
                        return res.id !== change.doc.id;
                    });
                }
            });
            setResList(newList);
        }); 

        // Get Recommendations

        const q2 = query(collection(props.eDB, 'Recommendations'));
        const unsubscribe_rec = onSnapshot(q2, (snapshot) => {
            let newList = recommendListRef.current.slice();

            snapshot.docChanges().forEach((change) => {
                if(change.type === "added"){
                    let elem = {...change.doc.data(),id: change.doc.id};
                    newList.push(elem);
                }

                if(change.type === "modified"){
                    let index = recommendListRef.current.findIndex((rec) => { return rec.id === change.doc.id});
                    newList.splice(index, 1, {...change.doc.data(), id: change.doc.id});
                }

                if(change.type === "removed"){
                    newList = newList.filter((res) => {
                        return res.id !== change.doc.id;
                    });
                }
            });
            setRecList(newList);
        }); 

        return () => {
            unsubscribe_res();
            unsubscribe_rec();
        };
    }, [props.eDB]);    
    
    const open = (id, data) => {
        console.log(`Abrir: ${data.name}`);
    }

    const edit = (id, data) => {
        setCurrentRes({...data, id: id});
    }

    const remove = (id, data) => {
        showPopUp('Borrar Restaurante', <DeleteRes id={id} data={data} eDB={props.eDB} storage={props.storage} close={callback.closePopup} />);
    }

    const showPopUp = (title, content) => {
        setPopTitle(title);
        setPopContet(content);
        togglePopUp(true);
    }

    const hidePopUp = () => {
        togglePopUp(false);
        setPopContet(<></>);
    }

    const callback = {
        open: open,
        edit: edit,
        remove: remove,
        showPopup: showPopUp,
        closePopup: hidePopUp
    }

    return (
        <div className="MainContainer">
            <ProSidebar collapsed={sidebarCollapse} toggled={sidebarShow} breakPoint="sm" onToggle={(value) => toggleSidebar(value)}>
                <SidebarHeader>
                    <div className='sideHeader'>
                        <img src={logo320} className={sidebarCollapse?'collapsed':'logo'} alt='Quinek' />
                        <span style={{display: sidebarCollapse?'none':'block'}} className='title tx-white'>uinek</span>
                    </div>
                </SidebarHeader>
                
                <Menu iconShape="circle">
                    <MenuItem onClick={() => {changeMainPath(''); toggleSidebar(false);}} icon={<MdDashboard />}>Inicio</MenuItem>
                    <MenuItem onClick={() => {changeMainPath('Recommends'); toggleSidebar(false);}} icon={<MdVerified />}>Recomendaciones</MenuItem>
                    <MenuItem onClick={() => {changeMainPath('Restaurants'); toggleSidebar(false);}} icon={<MdFastfood />}>Restaurantes</MenuItem>
                </Menu>

                <SidebarFooter className='py-2 d-dinamic-inv'>
                    {
                        sidebarCollapse ? (
                            <button className="cbtn d-block" onClick={() => collapseSidebar(!sidebarCollapse)}>
                                <MdChevronRight size='1.5rem' style={{margin: 'auto'}} />
                            </button>
                        ) : (
                            <button className="cbtn d-block" onClick={() => collapseSidebar(!sidebarCollapse)}>
                                <MdChevronLeft size='1.5rem' style={{margin: 'auto'}} />
                            </button>
                        )
                    }
                </SidebarFooter>
                <div style={{height: '100%'}} />
                <div className={(sidebarCollapse?'footer':'collapsedFooter')+' d-flex jf-center p-1'}>
                    <a className='d-flex tx-alt' href='https://github.com/Stevengez' target='blank'>Developed by S7evenSoftware</a>
                </div>
            </ProSidebar>

            {
                isPopUp && <>
                    <div className='Popupblur' />
                    <div className='PopupContainer'>
                        <div className='Popup d-block'>
                            <div className='Topbar pb-2'>
                                <div className='title'>
                                    {popTitle}
                                </div>
                                <div>
                                    <button className='cbtn bg-primary' onClick={hidePopUp}>
                                        <MdClose size='1rem' color='white' pointerEvents="none"/>
                                    </button>
                                </div>
                            </div>
                            <div className='popscrollable'>
                                {
                                    popContent
                                }
                            </div>
                        </div>
                    </div>
                </>
            }            

            <div className='InnerContainer'>
                <TopBar auth={props.auth} toggle={sidebarShow} toggleMethod={toggleSidebar} collapseBar={collapseSidebar} router={changeMainPath}/>
                <Routes>
                    <Route path='/' element={ <Welcome /> } />
                    <Route path="/Recommends" element={ <Recommends recommendList={recommendList} restaurantList={restaurantList} setRecList={setRecList} storage={props.storage} eDB={props.eDB} callback={callback} router={changeMainPath} />} />
                    <Route path="/Restaurants" element={ <Restaurants restaurantList={restaurantList} setResList={setResList} storage={props.storage} eDB={props.eDB} callback={callback} router={changeMainPath} />} />
                    <Route path="/Edit/:resID" element={ <RestaurantEditor currentRestaurant={currentRestaurant} storage={props.storage} eDB={props.eDB} callback={callback} router={changeMainPath}/>} />
                    <Route path="/Edit/:resID/Menu" element={ <MenuEditor currentRestaurant={currentRestaurant} storage={props.storage} eDB={props.eDB} callback={callback} router={changeMainPath} />} />
                    <Route path="/New/:resID" element={ <RestaurantEditor storage={props.storage} eDB={props.eDB} callback={callback} router={changeMainPath} new/>} />
                </Routes>
                <Outlet />
            </div>
        </div>
    )
}

export default MainView;